import { SourceMap } from '../types'

const LOCAL_ENTITY = 'Company'

export const findSourceMapRecords = (
  sourceMaps: SourceMap[],
  ownerId: string,
  counterpartyId: string,
  sourceEntity: string
) =>
  sourceMaps.filter(
    sourceMap =>
      sourceMap.companyId === ownerId &&
      sourceMap.localEntity === LOCAL_ENTITY &&
      sourceMap.sourceEntity === sourceEntity &&
      sourceMap.identifiers.some(
        identifier => identifier.identifierType === 'local' && identifier.value === counterpartyId
      )
  )
